<template>
  <el-dialog title="详情" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="formData" :rules="formRules" ref="form">

      <el-table class="custom mt10" :data="formData.content" border stripe>
        <el-table-column label="标题">
          <template slot-scope="scope">{{ scope.row.question }}</template>
        </el-table-column>
        <el-table-column label="选择或填写">
          <template slot-scope="scope">
            <p v-if="scope.row.image"><el-image class="imgw100" :src="scope.row.image" fit="cover" :preview-src-list="[scope.row.image]" alt="" /></p>
            <p v-else>{{ scope.row.answer }}</p>
            <p v-if="scope.row.text" class="blue">{{ scope.row.text }}</p>
          </template>
        </el-table-column>
      </el-table>
      
    </el-form>
    <!--操作按钮-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      /*是否加载中*/
      loading: false,
      /*form表单数据对象*/
      formData: {},
      /*验证规则*/
      formRules: {},
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false,
    };
  },
  props: ['is_open', 'selectModel'],
  created() {
    this.dialogVisible = this.is_open;
    this.formData = this.selectModel;
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/custom/list/detail.vue